import type { FileType } from '@/types/upload';

export const getBase64 = (file: FileType): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const convertPolicyHtml = (body: string) => {
  return body
    .replace(/style="[^"]*"/g, '')
    .replace(/<br\s*>/gi, '<br />')
    .replace(/\s*tabindex="-1"/gi, '')
    .replace(/\s*start="[^"]*"/gi, '')
    .replace(
      /<span\s+role=["']presentation["']\s+className=["']heading-anchor-wrapper["'][^>]*>[\s\S]*?<\/span><\/button><\/span>/gi,
      ''
    );
};
